import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../layout";
import FormTextField from "../../../components/form/text";
import { FormImageField } from "../../../components/form/image";
import { FormTextAreaField } from "../../../components/form/text-area";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../../config";
import successToast from "../../../components/toast/successToast";
import errorToast from "../../../components/toast/errorToast";
import { useEffect, useState } from "react";
import ResetPasswordModal from "../../../components/modal/reset-password-modal";

const EditUsers = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);

  const initialValues = {
    id: params?.id,
    profile_picture: data?.profile_picture ?? "",
    email: data?.email ?? "",
    name: data?.name ?? "",
    description: data?.description ?? "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required").email("Invalid email"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    axios
      .post(`${url}/ffadmin/edit`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/admin/users/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/ffadmin/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <MainLayout>
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                Admin Users - Edit
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  type="button"
                  onClick={() => setOpenResetPassowrd(true)}
                  className="px-4 py-1 bg-white border-[2px] border-primary text-primary rounded"
                >
                  Reset password
                </button>
                <button
                  onClick={() => naviagte("/admin/users/list")}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Save
                </button>
              </div>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormImageField
                  name={"profile_picture"}
                  label={"profile picture"}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"name"}
                  label={"name"}
                  placeholder={`Enter your name`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"email"}
                  label={"Email"}
                  placeholder={`Enter your email`}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"description"}
                  label={"Description"}
                  placeholder={`Enter description`}
                />
              </div>
            </section>
          </Form>
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditUsers;
